import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// URL 검색 파라미터 스키마
const marketSearchSchema = z.object({
  category: z.string().optional().catch(undefined), // category_id 저장
});

/**
 * 마켓 플레이스 라우트 (/market)
 *
 * validateSearch로 URL 검색 파라미터를 검증합니다.
 * - category: 선택된 카테고리 ID (없으면 전체)
 * 컴포넌트는 market.lazy.tsx에서 자동으로 코드 스플리팅됩니다.
 */
export const Route = createFileRoute('/market')({
  validateSearch: marketSearchSchema,
});
